import { FC, useCallback, useMemo } from 'react';
import keyBy from 'lodash/keyBy';
import { fetchUsersQuery } from 'api/queries/users';
import { useGraphql } from 'utils/hooks/useGraphql';
import { UsersQueryContext } from './UsersQueryContext';
import { UsersResponse } from '../types';

export const UsersQueryContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const {
    data: { users = [] } = {},
    refetch: refetchUsers,
    isLoading: isLoadingUsers,
  } = useGraphql<UsersResponse>(fetchUsersQuery);

  const usersById = useMemo(() => keyBy(users, (user) => user.id), [users]);

  const getUserById = useCallback((id: string) => usersById[id], [users]);

  return (
    <UsersQueryContext.Provider
      value={{
        getUserById,
        isLoadingUsers,
        refetchUsers,
        users,
      }}
    >
      {children}
    </UsersQueryContext.Provider>
  );
};
